import {ResourceAllocationState, ProjectPerson} from '../../../types';

export const projectPersonHandlers = {
    ProjectPersonAdded: (
        state: ResourceAllocationState,
        data: ProjectPerson
    ): ResourceAllocationState => {
        return {
            ...state,
            projectPeople: {
                ...state.projectPeople,
                [data.id]: data
            }
        };
    },
    ProjectPersonUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<ProjectPerson>}
    ): ResourceAllocationState => {
        return {
            ...state,
            projectPeople: {
                ...state.projectPeople,
                [data.id]: {
                    ...state.projectPeople[data.id],
                    ...data.updates
                }
            }
        };
    },
    ProjectPersonDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.projectPeople;
        return {...state, projectPeople: rest};
    }
};
